angular.module('homebot.directives')

  .directive('supportLink', ['UtilService', function(utils){
    return {
      restrict: 'AE',
      controllerAs: 'supportCtrl',
      bindToController: {
        message: '@',
      },
      template: '',
      scope: {},
      controller: function(){
        var ctrl = this;
        ctrl.message = ctrl.message || '';

        ctrl.contactSupport = function(){
          if(window.Intercom)
            window.Intercom('showNewMessage', ctrl.message);

          utils.track('ContactSupport');
        };
      },

      link: function(scope, el, attrs, ctrl){
        el.on('click', (e) => {
          ctrl.contactSupport();
          e.preventDefault();
        });
      }
    }
  }]);
